import { render, staticRenderFns } from "./ChatBoxTextImg.vue?vue&type=template&id=3b7eb896&scoped=true&"
import script from "./ChatBoxTextImg.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTextImg.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTextImg.vue?vue&type=style&index=0&id=3b7eb896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7eb896",
  null
  
)

export default component.exports